import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 85vh;
  h2,
  p {
    width: 80%;
    margin: 1rem auto;
    text-align: center;
  }

  @media only screen and (min-width: 867px) {
  }
`;
